import * as React from "react";
const SvgFiRrSupplier = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-supplier_svg__a)">
      <path
        fill="#062147"
        d="M9 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6M9 2c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m12 12h-5c-1.654 0-3 1.346-3 3v4c0 1.654 1.346 3 3 3h5c1.654 0 3-1.346 3-3v-4c0-1.654-1.346-3-3-3m1 7c0 .552-.449 1-1 1h-5c-.551 0-1-.448-1-1v-4c0-.552.449-1 1-1h5c.551 0 1 .448 1 1zm-2-3a1 1 0 0 1-1 1h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 1 1m-9.351-1.072a1 1 0 0 1 .112 1.41l-.5.586a1 1 0 0 1-.207.183 1.91 1.91 0 0 1-2.487-.331l-2.331-2.767a6.95 6.95 0 0 0-3.237 5.886V23a1 1 0 1 1-2 0v-1.105a8.96 8.96 0 0 1 4.148-7.571 2.01 2.01 0 0 1 2.618.397l2.211 2.625.261-.307a1 1 0 0 1 1.41-.111z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-supplier_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrSupplier;
